function decodeHtmlEntities(value: string): string {
  return value.replaceAll('&amp;', '&');
}

export function toSafeExternalUrl(
  rawUri: string,
  isProduction = import.meta.env.PROD,
): string | null {
  const normalized = decodeHtmlEntities(rawUri.trim());

  if (!normalized) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(normalized);
  } catch {
    return null;
  }

  if (parsed.protocol === 'https:') {
    return parsed.toString();
  }

  if (!isProduction && parsed.protocol === 'http:') {
    return parsed.toString();
  }

  return null;
}
